// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// TODO: 留个标记
import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/styles/main.css'
import '@/assets/styles/element-ui.css'
import store from "./store/user";
import VCharts from 'v-charts'
import moment from 'moment'
import lodash from 'lodash'
import Sortable from "sortablejs";
import Meta from 'vue-meta'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'


moment.locale('zh-cn');

Vue.prototype.$moment = moment; //赋值使用
Vue.prototype._ = lodash;
Vue.prototype.Sortable = Sortable;

Vue.config.productionTip = false
Vue.use(VueQuillEditor);
Vue.use(ElementUI)
Vue.use(Router);
Vue.use(VCharts);
Vue.use(Meta);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js